import React, { Component } from 'react';
import styled from 'styled-components';
import { generateRecaptcha } from '../services/Recaptcha';
import { POST } from '../services/HttpRequests';
import TwoFAAuthentication from './TwoFAAuthentication';
import AlohaaLogo from '../assets/images/AlohaaLogoWhite.png';
import InfoRed from '../assets/images/infoRed.png';
import { AuthContext } from '../providers/AuthProvider';

const orgUrl = process.env.REACT_APP_ORGANIZATION_API;

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI;
const googleLoginUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URI}&response_type=code&scope=profile email`;

const GradientDiv = styled.div`
  height: 98px;
  background: linear-gradient(#f8153b, #920c23);
  display: flex;
  flex-direction: row;
`;

const DailerDiv = styled.div`
  height: 295px;
  background: white;
  border-radius: 0px 0px 10px 10px;
`;

const LoginButton = styled.div`
  width: 230px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 32px;
  background: #07aa3f;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;


class LoginPage extends Component {
  state = {
    checkboxChecked: false,
    step: 1,
    username: '',
    password: '',
    error: '',
    isLoading: false,
  };
  static contextType = AuthContext; 

  handleForgotPasswordClick = () => {
    this.props.history.push('/signup');
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleStep = () => {
    this.setState({step:1})
  }

  handleGoogleLogin = () => {
    const width = 500;
    const height = 600;

    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;

    const loginWindow = window.open(
      googleLoginUrl,
      'Google Login',
      `width=${width},height=${height},top=${top},left=${left}`
    );

    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === 'GOOGLE_LOGIN_SUCCESS') {
        this.context.saveSession(event.data?.res);

        window.removeEventListener('message', handleMessage);
        loginWindow.close();
      } else if (event.data?.type === 'GOOGLE_LOGIN_ERROR') {
        this.setState({ error: "Login Failed Try Again" })
        console.error('Google login error:', event.data.error);
        window.removeEventListener('message', handleMessage);
        loginWindow.close();
      }
    };

    // Listen for postMessage from popup
    window.addEventListener('message', handleMessage);
  };

  submitCredentialsHandler = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const recaptcha = generateRecaptcha('BUSINESS_LOGIN');
    let reqBody = {
      username: this.state.username,
      password: this.state.password,
      recaptchaToken: recaptcha,
    };

    this.setState({ isLoading: true });

    POST(`${orgUrl}v1/auth/login`, reqBody)
      .then((res) => {
        return res.data.response;
      })
      .then((res) => {
        if(res.role === "USER"){
          this.context.saveSession(res);
          this.setState({
            isLoading: false,
          });
          // return res;
        }
        else {
          this.setState({
            error: "Use Only Agent Login",
            isLoading: false,
          });
        }  
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.error
        ) {
          this.setState({
            error: err.response.data.error.reason,
            isLoading: false,
          });
        }
      });
  };

  render() {
    const {
      step,
      username,
      password,
      error,
      checkboxChecked,
      is_2FA_enabled,
      secret,
      organisation_id,
      user_id,
      isLoading,
    } = this.state;


    if (step === 2) {
      return (
        <TwoFAAuthentication
          is_2FA_enabled={is_2FA_enabled}
          secret={secret}
          error={error}
          organisation_id={organisation_id}
          user_id={user_id}
          resendOtp={this.submitCredentialsHandler}
          handleStep={this.handleStep}
          password={password}
          {...this.state}
        />
      );
    }

    return (
      <div className='LoginDiv'
        style={{
          background: 'white',
          display: 'block',
          width: '320px',
          height: '540px',
          boxShadow: '0px 0px 4px 0px black',
        }}
      >
        <GradientDiv>
          <div
            style={{
              position: 'absolute',
              marginTop: '24px',
              marginLeft: '24px',
            }}
          >
            <img src={AlohaaLogo} width={24} height={20} alt='alohaa'></img>
          </div>
          <p
            style={{
              position: 'absolute',
              marginTop: '60px',
              marginLeft: '24px',
              color: 'white',
              fontSize: '15px',
              fontWeight: 700,
            }}
          >
            Alohaa Login{' '}
          </p>
        </GradientDiv>
        <DailerDiv >
          <p
            style={{
              margin: '0px 110px 10px 40px',
              color: '#9B9B9B',
              font: 'Montserrat',
              fontWeight: 400,
              fontSize: '14px',
              paddingTop: '15px',
            }}
          >
            Email or phone number
          </p>
          <input
            id="username"
            type={'text'}
            value={username}
            style={{
              height: '36px',
              width: '216px',
              display: 'block',
              margin: '0px auto',
              border: '1px solid #9B9B9B',
              borderRadius: '5px',
              marginTop: '5px',
              color: 'black',
              background:'white',
            }}
            onChange={
              this.handleChange
            }
          ></input>
          <p
            style={{
              margin: '15px 125px 10px 40px',
              color: '#9B9B9B',
              font: 'inherit',
              fontWeight: 400,
              fontSize: '14px',
            }}
          >
            Password
          </p>
          <input
            id="password"
            type={'password'}
            value={password}
            style={{
              height: '36px',
              width: '216px',
              display: 'block',
              margin: '0px auto',
              marginTop: '5px',
              border: '1px solid #9B9B9B',
              borderRadius: '5px',
              color: 'black',
              background:'white',
            }}
            onChange={
              this.handleChange
            }
          ></input>
          <a
            style={{
              margin: '25px 125px 10px 40px',
              font: 'inherit',
              fontWeight: 400,
              fontSize: '14px',
              color: '#196CCA',
              position:'relative',
              left: '110px',
            }}
            href='https://business.alohaa.ai/forgot-password'
            target="_blank"
            rel='noreferrer'
          >Forgot password</a>
          <LoginButton
            style={{ 
              margin: '35px auto 0px auto',
              color: 'white',
              fontWeight: 700,
              fontSize: '14px'
            }}
            onClick={this.submitCredentialsHandler}
          >
            Login
          </LoginButton>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '10px',
              width: '100%',
              maxWidth: '280px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <div style={{ flex: 1, height: '1px', background: '#d2d3d4' }} />
            <span style={{ margin: '0 8px', fontSize: '16px', fontWeight: 'bold', color: '#d2d3d4' }}>Or</span>
            <div style={{ flex: 1, height: '1px', background: '#d2d3d4' }} />
          </div>
          <div
          onClick={this.handleGoogleLogin}
          style={{
            padding: '14px',
            border: '1px solid #d2d3d4',
            marginTop: '10px',
            marginLeft: '10px',
            marginRight: '10px',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <a
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                letterSpacing: '0.75px',
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
            <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIj4KICAgIDxwYXRoIGQ9Ik0zLjU0NTk0IDkuNjY4OTlMMi45ODkgMTEuNzQ4MUwwLjk1MzQwNiAxMS43OTEyQzAuMzQ1MDYzIDEwLjY2MjggMCA5LjM3MTg2IDAgNy45OTk5OUMwIDYuNjczMzkgMC4zMjI2MjUgNS40MjIzOSAwLjg5NDUgNC4zMjA4NkgwLjg5NDkzOEwyLjcwNzE5IDQuNjUzMTFMMy41MDEwNiA2LjQ1NDQ5QzMuMzM0OTEgNi45Mzg4OSAzLjI0NDM0IDcuNDU4ODkgMy4yNDQzNCA3Ljk5OTk5QzMuMjQ0NDEgOC41ODcyNCAzLjM1MDc4IDkuMTQ5ODkgMy41NDU5NCA5LjY2ODk5WiIgZmlsbD0iI0ZCQkIwMCIvPgogICAgPHBhdGggZD0iTTE1Ljg2MDQgNi41MDU2MkMxNS45NTIyIDYuOTg5NTUgMTYuMDAwMSA3LjQ4OTMzIDE2LjAwMDEgOC4wMDAxMkMxNi4wMDAxIDguNTcyODcgMTUuOTM5OSA5LjEzMTU1IDE1LjgyNTIgOS42NzA0NkMxNS40MzU4IDExLjUwNDMgMTQuNDE4MiAxMy4xMDU2IDEzLjAwODUgMTQuMjM4OEwxMy4wMDgxIDE0LjIzODRMMTAuNzI1NSAxNC4xMjE5TDEwLjQwMjQgMTIuMTA1MkMxMS4zMzc4IDExLjU1NjYgMTIuMDY4OCAxMC42OTgxIDEyLjQ1MzggOS42NzA0Nkg4LjE3NjAzVjYuNTA1NjJIMTIuNTE2MkgxNS44NjA0WiIgZmlsbD0iIzUxOEVGOCIvPgogICAgPHBhdGggZD0iTTEzLjAwNzkgMTQuMjM4MkwxMy4wMDgzIDE0LjIzODZDMTEuNjM3MyAxNS4zNDA2IDkuODk1NzcgMTUuOTk5OSA3Ljk5OTk2IDE1Ljk5OTlDNC45NTMzNyAxNS45OTk5IDIuMzA0NTkgMTQuMjk3MSAwLjk1MzM2OSAxMS43OTExTDMuNTQ1OSA5LjY2ODk1QzQuMjIxNDkgMTEuNDcyIDUuOTYwODQgMTIuNzU1NSA3Ljk5OTk2IDEyLjc1NTVDOC44NzY0MyAxMi43NTU1IDkuNjk3NTYgMTIuNTE4NiAxMC40MDIyIDEyLjEwNUwxMy4wMDc5IDE0LjIzODJaIiBmaWxsPSIjMjhCNDQ2Ii8+CiAgICA8cGF0aCBkPSJNMTMuMTA2NCAxLjg0MTc1TDEwLjUxNDggMy45NjM1QzkuNzg1NTMgMy41MDc2OSA4LjkyMzUzIDMuMjQ0MzcgOC4wMDAwMyAzLjI0NDM3QzUuOTE0NzUgMy4yNDQzNyA0LjE0Mjg4IDQuNTg2NzggMy41MDExMyA2LjQ1NDVMMC44OTQ5NjkgNC4zMjA4OEgwLjg5NDUzMUMyLjIyNTk3IDEuNzUzODQgNC45MDgxNiAwIDguMDAwMDMgMEM5Ljk0MTEyIDAgMTEuNzIwOSAwLjY5MTQzNyAxMy4xMDY0IDEuODQxNzVaIiBmaWxsPSIjRjE0MzM2Ii8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMCI+CiAgICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K" style={{ paddingRight: '8px' }} />
            Login with Google
            </a>
          </div>
          <div
            style={{
              color: 'red',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '25px 5px 0px 0px'
            }}
          >
            {error && (
            <React.Fragment>
              <img
                alt=""
                src={InfoRed}
                style={{
                  padding: '5px 0px 0px 0px',
                  position: 'relative',
                  top: '-2px',
                }}
              />
              {error}
            </React.Fragment> 
            )}
          </div>
          <p style={{ fontWeight: 500, flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Read our&nbsp;
            <a
              style={{
                color: '#ed3833',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              target="_blank"
              href="https://www.alohaa.ai/privacy-policy" rel="noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </DailerDiv>
      </div>  
    );
  }
}

export default LoginPage;
